import instance from 'services/api';
import { MASTER_ENDPOINT } from 'utils/Constant';

export const fetchAuthenticatedFileBlob = (fileId: string) =>
  instance
    .get(`${MASTER_ENDPOINT.Files}/${fileId}`, { responseType: 'blob' })
    .then((res) => res.data as Blob);
